import { permanentWays } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function PermanentEntrySection() {
  return (
    <section id="entry" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <SectionHeading
              eyebrow="防走丢"
              title="永久入口与收藏方法"
              desc="地址会变，固定入口不变。把获取最新地址的页面长期保存下来，无论地址怎么更换，都能从这里重新找到正确的入口。"
            />

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {permanentWays.map((way) => (
                <div key={way.title} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-secondary-900">
                    <i className={`${way.icon} text-lg`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{way.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{way.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="h-64 w-full overflow-hidden md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=Neatly%20arranged%20warm%20colored%20sticky%20notes%20and%20a%20paper%20bookmark%20on%20a%20soft%20cream%20desk%2C%20minimal%20flat%20lay%20composition%2C%20warm%20amber%20tones%2C%20soft%20natural%20light%2C%20editorial%20photography%20with%20generous%20negative%20space%2C%20no%20text%2C%20no%20people&width=1000&height=800&seq=hantv-entry-01&orientation=squarish"
                alt="用便签与书签记录入口地址，便于长期保存"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="p-5">
              <p className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                <span className="flex h-5 w-5 items-center justify-center text-primary-600">
                  <i className="ri-pushpin-2-line"></i>
                </span>
                现在就做三件事
              </p>
              <ul className="mt-3 space-y-2 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  把本页加入浏览器收藏夹
                </li>
                <li className="flex items-start gap-2">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  在云笔记中再备份一次入口
                </li>
                <li className="flex items-start gap-2">
                  <span className="flex h-4 w-4 shrink-0 items-center justify-center text-primary-600">
                    <i className="ri-check-line text-sm"></i>
                  </span>
                  需要时回访本页确认最新地址
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}